<div
  *ngIf="newsletterFormView"
  class="form-view primary-color-border-bottom"
  data-test="newsletter-prompt"
>
  <p class="h5 newsletter-prompt px-0">
    Get the most important {{ sportName$ | async }} stories delivered straight to your inbox.
  </p>
  <form
    class="flo-input-form newsletter-form my-3"
    [formGroup]="newsletterForm"
    (ngSubmit)="submitForm()"
  >
    <div class="input-wrapper me-2 position-relative" data-test="newsletter-placeholder">
      <input
        (click)="sendClickEvent()"
        type="email"
        floAnalytics
        name="Email"
        [events]="['click', 'focus']"
        formControlName="email"
        placeholder="Email Address"
        autocomplete="off"
        maxlength="75"
        class="form-control"
      />
      <div
        class="primary-color-text spinner-border spinner-border-sm"
        role="status"
        *ngIf="emailSpinner$ | async as emailSpinner"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
      <flo-form-errors
        *ngIf="showErrorBoxMessage('email')"
        [errors]="email?.errors"
        control="newsletterFormEmail"
      >
      </flo-form-errors>
    </div>
    <div>
      <button
        type="submit"
        class="btn btn-primary btn-subscribe"
        data-test="newsletter-submit"
        [disabled]="newsletterForm?.invalid"
        [ngClass]="{ 'primary-color-bg': newsletterForm?.valid }"
      >
        Sign Up
        <div
          class="spinner-border spinner-border-sm"
          role="status"
          *ngIf="newsletterFormSubmitting"
        >
          <span class="visually-hidden">Loading...</span>
        </div>
      </button>
    </div>
  </form>
  <div class="caption color-600">
    By submitting my information, I agree to the <a [href]="termsOfServiceURL" target="_blank"> Terms of Service</a> and <a [href]="privacyPolicyURL" target="_blank">Privacy Policy</a> and to receive offers and promotions from {{ siteName$ | async }}. Unsubscribe anytime.
  </div>
</div>

<div
  *ngIf="!newsletterFormView"
  class="success-view border rounded border-grey-300 py-4 text-center"
  data-test="newsletter-success"
>
  <span class="mb-3 svg-wrapper svg-vertical-align-text-bottom"><flo-svg-icon icon="check-outline" width="1em"></flo-svg-icon></span>
  <p class="newsletter-thank-you mb-1">You're all set!</p>
  <p class="color-500 mb-1">
    Be on the lookout for stories, highlights, and more from {{ siteName$ | async }}.
  </p>
</div>
